import React from 'react';
import { DatePicker, Select, Button, Space } from 'antd';

const FilterToolbar = ({
  dateMode = 'single',
  dateValue,
  onDateChange,
  classOptions,
  classValue,
  onClassChange,
  statusOptions,
  statusValue,
  onStatusChange,
  onReset,
}) => {
  return (
    <Space style={{ display: 'flex', flexWrap: 'wrap' }} size={8}>
      {dateMode === 'single' ? (
        <DatePicker
          placeholder="按日期筛选"
          value={dateValue}
          onChange={onDateChange}
          allowClear
          aria-label="选择日期"
        />
      ) : (
        <DatePicker.RangePicker
          placeholder={['开始日期', '结束日期']}
          value={dateValue}
          onChange={onDateChange}
          allowClear
          aria-label="选择日期范围"
        />
      )}
      {classOptions && onClassChange !== undefined && (
        <Select
          placeholder="按班级筛选"
          style={{ minWidth: 160 }}
          options={classOptions}
          value={classValue}
          allowClear
          onChange={onClassChange}
          aria-label="选择班级"
        />
      )}
      {statusOptions && onStatusChange !== undefined && (
        <Select
          placeholder="按状态筛选"
          style={{ minWidth: 180 }}
          options={statusOptions}
          value={statusValue}
          allowClear
          onChange={onStatusChange}
          aria-label="选择状态"
        />
      )}
      {onReset && <Button onClick={onReset}>重置筛选</Button>}
    </Space>
  );
};

export default FilterToolbar;
